import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { Modal, Button, Menu, Dropdown, Tooltip, Icon } from 'antd';
import SubmitRationalityApprove from './Components/SubmitRationalityApprove';
import { All, Appoint } from './Components/AuthApprover';
import FeedbackOpinion from './Components/FeedbackOpinion';
import CustomOpinion from '../Components/CustomOpinion';
import ExportModal from './Components/ExportModal';
import Versions from './Components/Versions';
import Filter from './Components/Filter';
import Log from './Components/Log';
import TableC from '../../basicElement/TableC';
import Fetch from '../../../common/Fetch';
import API_URL from '../../../common/url';
import Update from '../Components/Update';
import actions from '../store/actions';
import fp from '../../../utils/fp';
import cf from '../../../utils/cf';
import '../style.less';

class Quotation extends Component {
    state = {
        data: [],
        loading: false,
        sortParams: {},
        searchParams: {},
        curParams: {},
        pagination: {
            pageSize: 10,
            current: 1,
        },
        updateVisible: false,
        type: '',
    }

    componentDidMount() {
        this.loadData();
    }

    loadData = () => {
        // const { sortParams, curParams, pagination } = this.state;
        // const { current, pageSize } = pagination;
        // this.setState({ loading: true });
        // Fetch.post(API_URL.dashboard.queryInvUserFteInfo, {
        //     offset: current,
        //     limit: pageSize,
        //     ...sortParams,
        //     ...curParams,
        // }).then(res => {
        //     const { datas, totalCount } = res;
        //     pagination.total = totalCount;
        //     this.setState({
        //         data,
        //         pagination,
        //         loading: false,
        //     });
        // }).catch(error => {
        //     console.error(error);
        //     this.setState({ loading: false });
        // });
        this.setState({
            data: [{
                quotationId: 1,
                quotationNum: '202009151652',
                version: 'V1',
                baName: '王利平',
                quotationStatus: '新建',
                salesforceId: 'ASK202009151652',
                language: 'zh',
                currency: 'CNY',
                hasGuidePrice: '1',
                guidePrice: 1231456,
            }]
        });
    }

    search = () => {
        const { pagination, searchParams } = this.state;
        const params = this.splitParams(searchParams);
        pagination.current = 1;
        this.setState({
            pagination,
            curParams: params,
        }, () => {
            this.loadData();
        });
    }

    splitParams = (params) => {
        const result = {};
        for (let [key, value] of Object.entries(params)) {
            const type = typeof value;
            if (type !== 'object' || value === null) {
                result[key] = value;
            }
        }
        return result;
    }

    handleFilterChange = (searchParams) => {
        this.setState({ searchParams });
    }

    reset = () => {
        this.setState({ searchParams: {} }, () => {
            this.search();
        });
    }

    delete = (record) => {
        Modal.confirm({
            iconType: 'question-circle',
            title: "确定要删除吗？",
            onOk: () => {
                const {
                    investigationJdeContractId,
                    contractRemittanceApplicationId,
                } = record;
                this.setState({ loading: true });
                Fetch.post(API_URL.contract.delContractRemittanceApplication, {
                    investigationJdeContractId,
                    contractRemittanceApplicationId,
                }).then(res => {
                    message.success(res.success);
                    this.setState({ loading: false }, () => {
                        this.loadData();
                    });
                }).catch(error => {
                    console.error(error);
                    this.setState({ loading: false });
                });
            },
        });
    }

    confirmConsent = () => {
        this.setState({ loading: true });
        Fetch.post(API_URL.contract.deleteJdeApply, {
            jdeApplyId,
        }).then(res => {
            message.success(res.success);
            this.setState({ loading: false }, () => {
                this.loadData();
            });
        }).catch(error => {
            console.error(error);
            this.setState({ loading: false });
        });
    }

    consent = () => {
        Modal.confirm({
            iconType: 'question-circle',
            title: <div style={{ marginLeft: 42 }}>客户确定同意此报价？</div>,
            content: '客户同意报价后，报价单数据不可再修改',
            onOk: () => {
                this.confirmConsent();
            },
        });
    }

    getColumns = () => {
        const columns = [{
            title: '报价单号',
            dataIndex: 'quotationNum',
            key: 'quotationNum',
            fixed: 'left',
            width: 100,
        }, {
            title: '服务类型（报价类型）',
            dataIndex: 'serverType',
            key: 'serverType',
            fixed: 'left',
            width: 160,
        }, {
            title: '提交对象',
            dataIndex: 'companyName',
            key: 'companyName',
            width: 160,
        }, {
            title: '方案编号',
            dataIndex: 'caseNum',
            key: 'caseNum',
            width: 100,
        }, {
            title: '试验药物',
            dataIndex: 'cityName',
            key: 'cityName',
            width: 100,
        }, {
            title: '治疗领域',
            dataIndex: 'hospitalName',
            key: 'hospitalName',
            width: 90,
        }, {
            title: '适应症',
            dataIndex: 'departmentLocalName',
            key: 'departmentLocalName',
            width: 120,
        }, {
            title: '币种',
            dataIndex: 'piName',
            key: 'piName',
            width: 80,
        }, {
            title: '报价单总价',
            dataIndex: 'investigationName',
            key: 'investigationName',
            width: 100,
        }, {
            title: 'BD',
            dataIndex: 'bdName',
            key: 'bdName',
            width: 60,
        }, {
            title: 'BA',
            dataIndex: 'baName',
            key: 'baName',
            width: 60,
        }, {
            title: '报价单版本',
            dataIndex: 'version',
            key: 'version',
            width: 80,
            render: (text, record) => {
                return <a onClick={() => this.showVersion(record)}>{text}</a>;
            }
        }, {
            title: '报价单状态',
            dataIndex: 'quotationStatus',
            key: 'quotationStatus',
            width: 120,
        }, {
            title: '操作',
            dataIndex: 'operation',
            key: 'operation',
            width: 200,
            fixed: 'right',
            render: (text, record) => {
                const { userName, curRole } = sessionStorage;
                const { quotationStatus, salesforceID, bdName, baName } = record;
                const hasStatus = fp.contains(quotationStatus);
                const isQuotationBa = (curRole === 'BA' || curRole === 'BAL') && userName === baName;
                const isQuotationBd = (curRole === 'BD' || curRole === 'BDM') && userName === bdName;
                const isCarbonCopy = '抄送人';
                const isProxyApprove = '代理审批人' || (curRole === 'BDM' && '报价单BD的上级汇报线最近一层BDM') || (curRole === 'BDO' && userName === '洪有源') || (curRole === 'VP' && userName === '任科');

                const operationCorrespondRoles = new Map([
                    ['viewCustomOpinion', {
                        name: '查看客户修改意见',
                        display: true,
                        editable: true,
                        event: () => this.showOpinion(record),
                        roles: ['BA', 'BAL', 'BD', 'BDM', 'BDO', 'VP', 'BO'],
                    }],
                    ['feedBackCustomOpinion', {
                        name: '反馈客户修改意见',
                        display: isQuotationBd && hasStatus(['BDO审批通过', 'BDM审批通过']),
                        editable: true,
                        event: () => this.feedbackOpinion(record),
                        roles: ['BD', 'BDM'],
                    }],
                    ['edit', {
                        name: '修改报价单',
                        display: isQuotationBa && hasStatus(['新建', 'BDM审批不通过', 'BDO审批不通过', 'BD已反馈修改意见']),
                        editable: true,
                        event: () => this.update(true, 'edit', record),
                        roles: ['BA', 'BAL'],
                    }],
                    ['cancel', {
                        name: '撤回报价单',
                        display: isQuotationBa && hasStatus(['待BDM合理性审批']) && '尚未审批',
                        editable: true,
                        event: () => void(0),
                        roles: ['BA', 'BAL'],
                    }],
                    ['delete', {
                        name: '删除',
                        display: isQuotationBa && hasStatus(['新建']),
                        editable: true,
                        event: () => this.delete(record),
                        roles: ['BA', 'BAL'],
                    }],
                    ['submitRationalityApprove', {
                        name: '提交合理性审批',
                        display: isQuotationBa && (hasStatus(['新建']) && salesforceID) || hasStatus(['根据审批意见修改中', '根据反馈意见修改中']),
                        editable: true,
                        event: () => this.showRationalityApprove(record),
                        roles: ['BA', 'BAL'],
                    }],
                    ['rationalityApprove', {
                        name: '合理性审批',
                        display: isProxyApprove && hasStatus(['待BDO合理性审批']),
                        editable: true,
                        event: () => this.update(true, 'approve', record),
                        roles: ['BA', 'BAL', 'BD', 'BDM', 'BDO', 'VP'],
                    }],
                    ['customeAgreeQuotation', {
                        name: '客户同意报价',
                        display: isQuotationBd && hasStatus(['BDO审批通过', 'BDM审批通过']),
                        editable: true,
                        event: () => this.consent(),
                        roles: ['BD', 'BDM'],
                    }],
                    ['viewQuotation', {
                        name: '查看报价单',
                        display: (
                            (isQuotationBa && hasStatus(['待BDM合理性审批', '待BDO合理性审批', 'BDM审批通过', 'BDO审批通过', '客户同意报价']))
                            || (isCarbonCopy)
                            || (isProxyApprove && !hasStatus(['待BDO合理性审批']))
                            || isQuotationBd
                        ),
                        editable: true,
                        event: () => this.viewQuotation(record),
                        roles: ['BA', 'BAL', 'BD', 'BDM', 'BDO', 'VP', 'BO'],
                    }],
                    ['operationLog', {
                        name: '操作日志',
                        display: true,
                        editable: true,
                        event: () => this.showLog(record),
                        roles: ['*'],
                    }],
                ]);
                return (
                    <span>
                        {   fp.compose(
                                fp.curry(cf.operationAuthByRole)(index => <span key={index} className="ant-divider" />),
                                fp.filter(i => !!i),
                                // 获取角色对应操作
                                fp.curry(cf.authDomList)(operationCorrespondRoles)
                            )(curRole)
                        }
                    </span>
                );
            }
        }];
        return columns;
    }

    handleTableChange = (params) => {
        this.setState({
            ...params,
        }, () => {
            this.loadData();
        });
    }

    export = () => {
        this.exportRef.show();
    }

    hide = () => {
        this.setState({ updateVisible: false });
    }

    update = (updateVisible, type, record = {}) => {
        this.setState({
            type,
            updateVisible
        });
        const { quotationStatus } = record;
        let status = 'add';
        if (quotationStatus === 'BDM审批不通过' || quotationStatus === 'BDO审批不通过' || quotationStatus === 'BD已反馈修改意见') {
            status = 'edit';
        } else if (quotationStatus === 'BDM审批不通过') {

        }
        this.props.saveQuotationInfo({ ...record, status });
    }

    viewQuotation = (record) => {
        Modal.confirm({
            iconType: 'question-circle',
            title: "请选择查看方式？",
            okText: '带修改痕迹',
            onOk: () => {
                this.props.saveQuotationInfo({ ...record, type: 'view', mode: 'compare' });
                location.href = './#/quotation/production';
            },
            cancelText: '无修改痕迹',
            onCancel: () => {
                this.props.saveQuotationInfo({ ...record, type: 'view' });
                location.href = './#/quotation/production';
            }
        });
    }

    showVersion = (record) => {
        this.versionsRef.show(record);
    }

    showOpinion = (record) => {
        this.opinionRef.show(record);
    }

    showLog = (record) => {
        this.logRef.show(record);
    }

    feedbackOpinion = (record) => {
        this.feedbackRef.show(record);
    }

    handleClick = e => {
        if (e.key === 'all') {
            this.allRef.show();
        } else {
            this.appointRef.show();
        }
    }

    showRationalityApprove = (record) => {
        this.rationalityApproveRef.show(record);
    }

    getBtn = () => {
        const menu = (
            <Menu onClick={this.handleClick} selectedKeys={[]}>
                <Menu.Item key="all">
                    <a>所有报价单授权</a>
                </Menu.Item>
                <Menu.Item key="appoint">
                    <a>指定申办方授权</a>
                </Menu.Item>
            </Menu>
        );
        const tipInfo = (
            <span>
                授权审批人后，这些人将暂代您的审批工作<br />
                【指定申办方授权，优先于所有报价单授权】
            </span>
        );
        return [
            <Dropdown key="dropdown" overlay={menu}>
                <Button type="primary" className="authApprover_btn" style={{marginLeft: 8}}>
                    授权审批人
                    <Icon type="down" />
                </Button>
            </Dropdown>,
            <Tooltip key="tooltip" placement="top" title={tipInfo} overlayClassName="quotation_tooltip">
                <a><Icon style={{ marginTop: 8, marginRight: 4, fontSize: '14px', color: '#5750c9' }} type="info-circle" /></a>
            </Tooltip>
        ];
    }

    render() {
        const { curRole, userName } = sessionStorage;
        const { data, loading, pagination, searchParams, sortParams, updateVisible, type } = this.state;
        return (
            <div className="full home quotation">
                <Filter
                    search={this.search}
                    params={searchParams}
                    onChange={this.handleFilterChange}
                    buttons={[
                        <Button key="reset" type="primary" onClick={this.reset} style={{marginLeft: 8}}>重置</Button>,
                        (curRole === 'BA' || curRole === 'BAL') && <Button key="add" type="primary" onClick={() => this.update(true, 'add')} style={{marginLeft: 8}}>添加报价单</Button>,
                        (curRole === 'BDM' || curRole === 'VP' || (curRole === 'BDO' && userName === '洪有源')) && <Button key="export" type="primary" onClick={this.export} style={{marginLeft: 8}}>导出</Button>,
                        ...((curRole === 'BDO' && userName === '洪有源') ? this.getBtn() : []),
                    ]}
                />
                <TableC
                    data={data}
                    loading={loading}
                    sortParams={sortParams}
                    columns={this.getColumns()}
                    className="quotation_tableC"
                    pagination={pagination}
                    onChange={this.handleTableChange}
                />
                <Log ref={el => this.logRef = el} />
                <All ref={el => this.allRef = el} />
                <Appoint ref={el => this.appointRef = el} />
                <Versions ref={el => this.versionsRef = el} />
                <ExportModal ref={el => this.exportRef = el} />
                <CustomOpinion ref={el => this.opinionRef = el} />
                <Update visible={updateVisible} type={type} hide={this.hide} />
                <FeedbackOpinion ref={el => this.feedbackRef = el} loadData={this.loadData} />
                <SubmitRationalityApprove ref={el => this.rationalityApproveRef = el} loadData={this.loadData} />
            </div>
        );
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        ...bindActionCreators(actions, dispatch),
    };
}

export default connect(null, mapDispatchToProps)(Quotation);


// WEBPACK FOOTER //
// ./src/components/quotation/list/index.js